import React from 'react';
import { Modal, Form, Input, Select, Button } from 'antd';

const { Option } = Select;

const AlterBug = ({ visible, onClose, onEdit, bug }) => {
  const [form] = Form.useForm();

  const handleSave = (values) => {
    if (values.descricao && values.tipo) {
      onEdit({ ...values, id: bug?.key });
      onClose(); // Fecha o modal após salvar
    }
  };

  return (
    <Modal
      title="Editar Bug"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <Form
        form={form}
        onFinish={handleSave}
        layout="vertical"
        initialValues={bug}
      >
        <Form.Item
          name="descricao"
          label="Descrição"
          rules={[{ required: true, message: 'Informe a descrição' }]}
        >
          <Input.TextArea />
        </Form.Item>
        <Form.Item
          name="tipo"
          label="Tipo"
          rules={[{ required: true, message: 'Selecione o tipo' }]}
        >
          <Select>
            <Option value="Erro">Erro</Option>
            <Option value="Melhoria">Melhoria</Option>
            <Option value="Nova Funcionalidade">Nova Funcionalidade</Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <div style={{ textAlign: 'right' }}>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit">
              Salvar
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AlterBug;
